export const emailMask = (rawValue) => {
  const value = rawValue || '';

  if (!value.includes('@')) {
    return Array(value.length + 1).fill(/[a-zA-Z0-9._%+-]/);
  }

  const indexOfAt = value.indexOf('@');

  return [
    ...Array(indexOfAt).fill(/[a-zA-Z0-9._%+-]/),
    '@',
    ...Array(value.length - indexOfAt - 1).fill(/[a-zA-Z0-9.-]/)
  ];
};
